import type {
  AuthActionControllerCompleteInviteData,
  AuthActionControllerCompleteInviteResponse,
  AuthActionControllerCreateData,
  AuthActionControllerCreateResponse,
  AuthActionControllerGetInviteData,
  AuthActionControllerGetInviteResponse,
  AuthActionControllerGetQrCodeData,
  AuthActionControllerGetQrCodeResponse,
} from '~/api';
import {
  authActionControllerCompleteInvite,
  authActionControllerCreate,
  authActionControllerGetInvite,
  authActionControllerGetQrCode,
} from '~/api';
import { heyApiQuery } from '~/utils/api';

import api from '..';

export const authAction = api.injectEndpoints({
  endpoints: builder => ({
    getInvite: builder.query<AuthActionControllerGetInviteResponse, AuthActionControllerGetInviteData['path']>({
      queryFn: params => heyApiQuery(() => authActionControllerGetInvite({ path: params })),
      providesTags: result => (result?.success ? [{ type: 'AUTH_INVITE_ACTION', id: result.data.id }] : []),
    }),
    getInviteQRCode: builder.query<AuthActionControllerGetQrCodeResponse, AuthActionControllerGetQrCodeData['path']>({
      queryFn: params => heyApiQuery(() => authActionControllerGetQrCode({ path: params })),
    }),
    invite: builder.mutation<AuthActionControllerCreateResponse, AuthActionControllerCreateData['body']>({
      queryFn: async body => heyApiQuery(() => authActionControllerCreate({ body })),
      invalidatesTags: () => [{ type: 'AUTH_INVITE_ACTION', id: 'ALL' }],
    }),
    inviteComplete: builder.mutation<
      AuthActionControllerCompleteInviteResponse,
      { id: AuthActionControllerCompleteInviteData['path']['id']; body: AuthActionControllerCompleteInviteData['body'] }
    >({
      queryFn: async ({ id, body }) => heyApiQuery(() => authActionControllerCompleteInvite({ path: { id }, body })),
    }),
    // paginateInvites
    // revokeInvite
    // deleteInvite,
  }),
  overrideExisting: false,
});
